/* ── Crown for the 3 most-tagged teams (1 gold · 2 silver · 3 bronze) ── */
const CROWN = {
    1: { label: 'Vàng', metal: ['#fff8c8', '#ffd84d', '#e3a500', '#8f6100'], gem: ['#ff8fb0', '#e12454', '#7a0a2c'] },
    2: { label: 'Bạc',  metal: ['#ffffff', '#eef1f5', '#aeb6c1', '#626a75'], gem: ['#9cc9ff', '#2c7be5', '#0e3a7a'] },
    3: { label: 'Đồng', metal: ['#ffe6cc', '#eba361', '#b8692b', '#653410'], gem: ['#8fe3b8', '#2d9b6f', '#0f4a32'] },
};

const BODY = 'M5.2 23 L2.8 10.8 Q3 10 3.8 10.5 L10.2 15.2 L15.2 6.6 Q16 5.6 16.8 6.6 L21.8 15.2 L28.2 10.5 Q29 10 29.2 10.8 L26.8 23 Z';

// 4-point twinkle star centred on (x, y)
const Spark = ({ x, y, r, delay, color }) => (
    <path
        className="team-crown-spark"
        style={{ animationDelay: `${delay}s` }}
        d={`M${x} ${y - r} Q${x} ${y} ${x + r} ${y} Q${x} ${y} ${x} ${y + r} Q${x} ${y} ${x - r} ${y} Q${x} ${y} ${x} ${y - r} Z`}
        fill={color}
    />
);

const Crown = ({ rank, count }) => {
    const c = CROWN[rank];
    const id = (k) => `crown-${k}-${rank}`;
    const edge = c.metal[3];
    return (
        <span className={`team-crown team-crown--${rank}`} title={`Top ${rank} ảnh được tag · ${count} ảnh`} aria-label={`Vương miện ${c.label} — top ${rank} ảnh được tag`}>
            <svg viewBox="0 0 32 32" aria-hidden="true">
                <defs>
                    <linearGradient id={id('metal')} x1="0" y1="0" x2="0.35" y2="1">
                        <stop offset="0%"   stopColor={c.metal[0]} />
                        <stop offset="35%"  stopColor={c.metal[1]} />
                        <stop offset="75%"  stopColor={c.metal[2]} />
                        <stop offset="100%" stopColor={c.metal[3]} />
                    </linearGradient>
                    <linearGradient id={id('band')} x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%"   stopColor={c.metal[1]} />
                        <stop offset="55%"  stopColor={c.metal[2]} />
                        <stop offset="100%" stopColor={c.metal[3]} />
                    </linearGradient>
                    <radialGradient id={id('pearl')} cx="0.35" cy="0.3" r="0.75">
                        <stop offset="0%"   stopColor="#ffffff" />
                        <stop offset="45%"  stopColor={c.metal[1]} />
                        <stop offset="100%" stopColor={c.metal[3]} />
                    </radialGradient>
                    <radialGradient id={id('gem')} cx="0.38" cy="0.3" r="0.8">
                        <stop offset="0%"   stopColor={c.gem[0]} />
                        <stop offset="50%"  stopColor={c.gem[1]} />
                        <stop offset="100%" stopColor={c.gem[2]} />
                    </radialGradient>
                    <clipPath id={id('clip')}>
                        <path d={BODY} />
                        <rect x="4.5" y="22.2" width="23" height="5" rx="1.6" />
                    </clipPath>
                </defs>

                {/* body */}
                <path d={BODY} fill={`url(#${id('metal')})`} stroke={edge} strokeWidth="0.7" strokeLinejoin="round" />
                {/* inner arch for depth */}
                <path d="M6.6 22 L5.6 14.6 L10.6 18.2 L16 10.4 L21.4 18.2 L26.4 14.6 L25.4 22 Z" fill={edge} opacity="0.16" />
                {/* left-edge highlight */}
                <path d="M5.9 21.6 L4.3 12.4 L6.2 13.8 L7.2 21.6 Z" fill="#fff" opacity="0.45" />

                {/* centre gem on the body */}
                <path d="M16 12.6 L19 16.6 L16 20.6 L13 16.6 Z" fill={`url(#${id('gem')})`} stroke={edge} strokeWidth="0.5" strokeLinejoin="round" />
                <path d="M16 12.6 L16 20.6 M13 16.6 L19 16.6" stroke="#fff" strokeOpacity="0.35" strokeWidth="0.4" />
                <circle cx="15" cy="15" r="0.75" fill="#fff" opacity="0.9" />

                {/* band */}
                <rect x="4.5" y="22.2" width="23" height="5" rx="1.6" fill={`url(#${id('band')})`} stroke={edge} strokeWidth="0.7" />
                <rect x="5.6" y="22.9" width="20.8" height="0.8" rx="0.4" fill="#fff" opacity="0.55" />
                <ellipse cx="16" cy="24.8" rx="2.1" ry="1.5" fill={`url(#${id('gem')})`} stroke={edge} strokeWidth="0.4" />
                <circle cx="9.6"  cy="24.8" r="1.1" fill={`url(#${id('pearl')})`} stroke={edge} strokeWidth="0.3" />
                <circle cx="22.4" cy="24.8" r="1.1" fill={`url(#${id('pearl')})`} stroke={edge} strokeWidth="0.3" />
                <circle cx="15.4" cy="24.2" r="0.45" fill="#fff" opacity="0.9" />

                {/* pearls on the tips */}
                <circle cx="3.1"  cy="10.2" r="1.8" fill={`url(#${id('pearl')})`} stroke={edge} strokeWidth="0.45" />
                <circle cx="16"   cy="5.3"  r="2.1" fill={`url(#${id('pearl')})`} stroke={edge} strokeWidth="0.45" />
                <circle cx="28.9" cy="10.2" r="1.8" fill={`url(#${id('pearl')})`} stroke={edge} strokeWidth="0.45" />

                {/* shine sweeping across the metal */}
                <g clipPath={`url(#${id('clip')})`}>
                    <g transform="skewX(-22)">
                        <rect className="team-crown-shine" x="-6" y="0" width="4" height="32" fill="#fff" opacity="0.6" />
                    </g>
                </g>

                {/* twinkles */}
                <Spark x={29.5} y={3.2} r={2.4} delay={0} color={c.metal[2]} />
                <Spark x={2.2}  y={4.4} r={1.6} delay={0.9} color={c.metal[2]} />
                {rank === 1 && <Spark x={24.5} y={0.6} r={1.3} delay={1.6} color={c.metal[2]} />}
            </svg>
            <b className="team-crown-rank">{rank}</b>
        </span>
    );
};

export default Crown;
